import { useSelector } from 'react-redux';

import { selectUser } from '@app/redux';

import { ProductInstanceStatus } from '@mfe/shared/schema-types';

export const useShowAddonsShop = (): boolean => {
  const {
    user: { productInstanceStatus, hasErrorProductInstance },
  } = useSelector(selectUser);

  const isUserActive = productInstanceStatus === ProductInstanceStatus.Active;

  return isUserActive && !hasErrorProductInstance;
};
